import styled from "styled-components";

export const OnErrorMessageBox = styled.div`
  width: 100%;
  padding: 0 5rem 5rem 5rem;
  font-size: 1.6rem;
  font-family: ${props => props.theme.font.family.light};
  color: ${({theme}) => theme.colors.bodyText.toString()};
  text-align: center;
  line-height: 1.2;
`;
